var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEngagement = function SvgEngagement(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4545 5.42611C15.4545 4.92778 15.0503 4.5238 14.5447 4.5238H1.81897C1.31646 4.5238 0.909089 4.93201 0.909089 5.42611V13.1215C0.909089 13.6198 1.31739 14.0238 1.81723 14.0238H3.63636V18.0952L7.72727 14.0238H14.5454C15.0475 14.0238 15.4545 13.6156 15.4545 13.1215V5.42611Z",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54546 1.80988C4.54546 1.30997 4.94967 0.904724 5.45534 0.904724H18.181C18.6835 0.904724 19.0909 1.3126 19.0909 1.80988V10.4043C19.0909 10.9042 18.6826 11.3095 18.1828 11.3095H16.3636V15.3809L12.2727 11.3095H5.45459C4.95249 11.3095 4.54546 10.9016 4.54546 10.4043V1.80988Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEngagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/engagement.1655b9a0.svg";
export { ForwardRef as ReactComponent };